<template>
    <section class="result-section">
      <h2 class="rsttl _trgbtmct"><slot name="jobname">保険業界の営業</slot>をのぞいてみた結果</h2>
        <fade-in-component>
          <div class="rsinner">
            <div class="block">
              <h3 class="rsttls"><slot name="title01">人を思いやるサポーター</slot></h3>
              <p class="rstxt">
                <slot name="explain01">
                人のためになる仕事をしたいという意識がとても強い傾向にあり、人の気持ちを汲み取ることにも長けています。
                <br />保険提案では、顧客の心配事や潜在的な不安を引き出してあげることより、最適なプランを検討していきます。その上で、顧客に寄り添い共感しながら、一緒に悩むことができる能力が必要であると考えられます。
                </slot>
              </p>
            </div><!-- .block -->
            <div class="block">
              <h3 class="rsttls"><slot name="title02">「万が一の備え」に演出はいらない</slot></h3>
              <p class="rstxt">
                <slot name="explain02">万が一の時に顧客の支えとなる保険では、魅力的な提案よりも安心感のある提案が求められます。そのため、提案内容のプレゼンやパフォーマンスといった”伝え方”に頼らず、顧客からの信頼や提案内容への納得感を得ることで契約に繋げようという意識の高い人が多いことが読み取れます。</slot>
              </p>
            </div><!-- .block -->
            <div class="rsbgimg">
              <slot name="imgperson"><img src="../assets/img/insurance/person.svg" alt="保険業界の営業" class="rsimg"></slot>
            </div>            
          </div><!-- .rsinner -->
          <div class="rssns">
            <p class="rssnstxt">
              あなたの思う「 {{setjob('name')}}の営業」はどんな人物でしょうか？<br>
              ご意見ご感想をお聞かせください
            </p>
            <ul class="sns-icons">
            <li class="list">


<a class="link" :href="setjob('fburl')" target="_blank" ><span class="iconfb">シェア</span></a>              
            </li>

              <li class="list">
<a :href="setjob('tw')" class="link" target="_blank"><span class="icontw">ツイート</span></a>

              </li>


            <li class="list">
              <a class="link" :href="setjob('line')" target="_blank"><span class="iconline">LINEで送る</span></a>
            </li>
            </ul>
          </div>
      </fade-in-component>
    </section>
</template>

<script>
import FadeInComponent from "../components/FadeInComponent.vue";

export default {
  props:["job"],
  components: {
    FadeInComponent
  },
  computed:{
    setjob(){
      return function(name){
        const url = "https://sales-score.jp/scope/"
        const tag = 'salesscope,営業,'
        const fburl01 = "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fsales-score.jp%2Fscope%2F"
        const fburl02 = "&amp;t="
        const line01 = "http://line.me/R/msg/text/?"
        const line02 = "%0d%0a" + url
        const tw01 = 'https://twitter.com/share?url='

        let params;
        let text;
        let slug;
        if(this.job == "staffagency"){
          text = "自信を持ちつつ慎重に考えるゼネラリスト？人材業界の営業職の特徴とは"
          slug = 'staffagency',
          params ={
            'name': '人材業界',
            'dataHt': tag+ '人材',
            'fburl': fburl01 + 'staffagency' + fburl02 + text,
            'line': line01 + text + line02 + slug,
            'tw' : tw01 + url + slug + '&text=' + text + '&hashtags=' + tag + '人材'
          }
        }else if(this.job == "it"){
          text = "内向的かつ理論重視？IT業界の営業職の特徴とは"
          slug = 'it',
          params ={
            'name': 'IT業界',
            'dataHt': tag + 'IT',
            'fburl': fburl01 + 'IT' + fburl02 + text,
            'line': line01 + text + line02 + slug,
            'tw' : tw01 + url + slug + '&text=' + text + '&hashtags=' + tag + 'IT'
          }
        }else if(this.job == "foodcompany"){
          text = "外向的で大胆なパートナー 食品メーカー業界の営業職の特徴とは"
          slug = 'foodcompany',
          params ={
            'name': '食品メーカー業界',
            'dataHt': tag + '食品メーカー',
            'fburl': fburl01 + 'foodcompany' + fburl02 + text,
            'line': line01 + text + line02 + slug,
            'tw' : tw01 + url + slug + '&text=' + text + '&hashtags=' + tag + '食品メーカー'
          }
        }else if(this.job == "cardealer"){
          text = "型にはまらない心配性な専門家？自動車業界の営業職の特徴とは"
          slug = 'cardealer',
          params ={
            'name': '自動車ディーラー業界',
            'dataHt': tag + '自動車ディーラー',
            'fburl': fburl01 + 'cardealer' + fburl02 + text,
            'line': line01 + text + line02 + slug,
            'tw' : tw01 + url + slug + '&text=' + text + '&hashtags=' + tag + '自動車ディーラー'
          }
        }else if(this.job == "shosha"){
          text = "外向的で大胆なパートナー？商社の営業職の特徴とは"
          slug = 'shosha',
          params ={
            'name': '商社',
            'dataHt': tag + '商社',
            'fburl': fburl01 + 'shosha' + fburl02 + text,
            'line': line01 + text + line02 + slug,
            'tw' : tw01 + url + slug + '&text=' + text + '&hashtags=' + tag + '商社'
          }
        }else if(this.job == "insurance"){
          text = "自信と慎重さを併せもったパートナー？保険業界の営業職の特徴とは"
          slug = 'insurance',
          params ={
            'name': '保険業界',
            'dataHt': tag + '保険',
            'fburl': fburl01 + 'insurance' + fburl02 + text,
            'line': line01 + text + line02 + slug,
            'tw' : tw01 + url + slug + '&text=' + text + '&hashtags=' + tag + '保険'
          }
        }else if(this.job == "bank"){
          text = "規律を重視する自信家？銀行業界の営業職の特徴とは"
          slug = 'bank',
          params ={
            'name': '銀行',
            'dataHt': tag + '銀行',
            'fburl': fburl01 + 'bank' + fburl02 + text,
            'line': line01 + text + line02 + slug,
            'tw' : tw01 + url + slug + '&text=' + text + '&hashtags=' + tag + '銀行'
          }
        }else if(this.job == "estate"){
          text = "大胆かつ好戦的なゼネラリスト？不動産業界の営業職の特徴とは"
          slug = 'estate',
          params ={
            'name': '不動産業界',
            'dataHt': tag + '不動産',
            'fburl': fburl01 + 'estate' + fburl02 + text,
            'line': line01 + text + line02 + slug,
            'tw' : tw01 + url + slug + '&text=' + text + '&hashtags=' + tag + '不動産'
          }
        }else if(this.job == "mr"){
          text = "外向的なゼネラリスト？製薬業界の営業職（MR）の特徴とは"
          slug = 'mr',
          params ={
            'name': '製薬業界（MR）',
            'dataHt': tag + '製薬',
            'fburl': fburl01 + 'mr' + fburl02 + text,
            'line': line01 + text + line02 + slug,
            'tw' : tw01 + url + slug + '&text=' + text + '&hashtags=' + tag + '製薬'
          }
        }else if(this.job == "securities"){
          text = "規律を重視する専門家？証券業界の営業職の特徴とは"
          slug = 'securities',
          params ={
            'name': '証券業界',
            'dataHt': tag + '証券',
            'fburl': fburl01 + 'securities' + fburl02 + text,
            'line': line01 + text + line02 + slug,
            'tw' : tw01 + url + slug + '&text=' + text + '&hashtags=' + tag + '証券'
          }
        }

        return params[name]
      }
    }

  },
  mounted: function () {
    // FB.XFBML.parse();
    // twttr.widgets.load();

  }
};
    !function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+'://platform.twitter.com/widgets.js';fjs.parentNode.insertBefore(js,fjs);}}(document, 'script', 'twitter-wjs');


</script>


